import {Breadcrumbs, type BreadcrumbsProps, Typography} from "@mui/material";
import ArrowIcon from '../../icons/svg/ChevronIcon.svg?react'
import {CustomSkeleton} from "../CustomSkeleton/CustomSkeleton";

interface Props extends BreadcrumbsProps {
    contents: string[];
    loading?: boolean;
}

export function CustomBreadcrumbs({contents, loading}: Props) {
    return <Breadcrumbs separator={<ArrowIcon fontSize="large"/>} aria-label="breadcrumb">
        {contents.filter(content => content).map(content => loading ?
            <CustomSkeleton key={content} width={200} height={32}/> :
            <Typography key={content} variant="h5" sx={{color: 'text.primary'}}>
                {content}
            </Typography>)}
    </Breadcrumbs>
}
